
export default function SearchBarDirective() {
    'ngInject';
    return {
        template: require("./search-bar.html"),
        transclude: true,
        restrict: 'E',
        scope: {
            enabled: '=',
            loading: '=',
            placeholder: '@',
            onClickButton: '&',
            onClickFiltersButton: '&',
            ngModel: '=',
            ngChange: '=',
            showFilters: '=',
            showingFilters: '=',
            filterCount: '=',
        }
    };
}
